module.exports = __webpack_public_path__ + "img/quiz_night_creation_show_selection.2cfb49cf.png";